import { ContextAction } from '../types';
import type { CoBrandDetailsAction, CoBrandDetailsState } from './types';

export const CoBrandDetailsInitial = {};

export const coBrandDetailsReducer = (
  state: CoBrandDetailsState = {},
  action: CoBrandDetailsAction
): CoBrandDetailsState => {
  switch (action.type) {
    case ContextAction.setCoBrandDetails:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
